<div class="simulator">
  <div class="blue-title">
    <div class="info-panel">
      <div class="info">
        <span class="text">VALOR A SER LIBERADO AO LOJISTA</span>
        <span class="value">{{
          opcoesPagamento[index].valor | currency: 'BRL'
        }}</span>
      </div>
      <div class="vertical-line"></div>
      <div class="info">
        <span class="text">DATA DE PAGAMENTO</span>
        <span class="value">{{
          opcoesPagamento[index].dataPagamento | date: 'dd/MM/yyyy'
        }}</span>
      </div>
    </div>
  </div>

  <div class="retention">
    <div class="retention-border">
      <span>Retenção: {{ opcoesPagamento[index].retencao }}%</span>
    </div>
  </div>

  <div class="white-selector">
    <div class="selector-title">
      <span> Opções de carência para recebimento </span>
    </div>

    <div class="button-row" #buttonRow>
      <button
        class="btn btn-full-orange"
        *ngFor="let opcaoPgmt of opcoesPagamento; let i = index"
        [ngClass]="{ focus: index === i }"
        [id]="'opcao' + opcaoPgmt.opcao"
        [value]="opcaoPgmt.opcao"
        (click)="onSelect(i)"
      >
        D +{{ opcaoPgmt.opcao }} {{ opcaoPgmt.opcao === 0 ? '*' : '' }}
      </button>
    </div>
  </div>

  <p *ngIf="opcoesPagamento[index].opcao === 0" class="spacing text-center">
    *O pagamento só será realizado em D+0 condicionado ao período de assinatura
    do Termo de Cessão, caso realizado após as 14:00 o pagamento ocorrerá no
    próximo dia útil.
  </p>
</div>
